import { MessageCost } from "./BatchMessageCostRequestModel";

export default class BatchMessageSchedulingDetailModel {
	public preSubmissionConfigurationId: string;
	public messages: MessageDetail[];
	public partitionKey: string;

	public constructor() {
		this.preSubmissionConfigurationId = "";
		this.messages = [];
		this.partitionKey = "";
	}
}

export class MessageDetail extends MessageCost {
	public title: string;
	public languageIds: string[];
	public dateTime: Date | string;
	public timezone: string;
	public isSelected?: boolean;
	public groupId: string;
	public isRecurring: boolean;
	public recurrenceDetails: RecurrenceDetail | undefined;

	public constructor() {
		super();
		this.languageIds = [];
		this.timezone = "";
		this.title = "";
		this.isSelected = false;
		this.groupId = "";
		this.dateTime = "";
		this.isRecurring = false;
		this.recurrenceDetails = undefined;
	}
}

export class RecurrenceDetail {
	public option: string;
	public days: number[];
	public date: string;

	public constructor(option: string, days: number[], date: string) {
		this.option = option;
		this.days = days;
		this.date = date;
	}
}
